<template>
    <div>
    <!-- <aside id="left-panel" class="left-panel">
        <nav class="navbar navbar-expand-sm navbar-default">

            <div class="navbar-header">
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main-menu" aria-controls="main-menu" aria-expanded="false" aria-label="Toggle navigation">
                    <i class="fa fa-bars"></i>
                </button>
                <div style="padding:15px 20px 13px 20px;">
                <a class="navbar-brand" href="./"><h2>{{userAccount.corpName}}</h2></a>
                </div>
            </div>
            <div id="main-menu" class="main-menu collapse navbar-collapse">
                <ul class="nav navbar-nav">
                    <li v-bind:class="{ 'active' : isActive('monitoring'), 'text-white': isActive('temp-main/monitoring') }">
                        <router-link to="/monitoring"><i class="menu-icon fa fa-table"></i>오더 모니터링</router-link>
                    </li>
                </ul>
            </div>
        </nav>
    </aside> -->
    <!-- /#left-panel -->
    <div id="right-panel" class="right-panel">

        <!-- Header-->
        <header id="header" class="header">

            <div class="header-menu">
                <div class="col-sm-12">
                    <div class="user-area dropdown float-right">

                        <!-- <a href="javascript:void(0)" class="dropdown-toggle mr-3" v-on:click="showUserDetail" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> -->
                        <a href="javascript:void(0)" class="dropdown-toggle mr-3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <strong class="text-info">{{userAccount.name}} </strong>님 반갑습니다
                        </a>
                        <a href="javascript:void(0)" class="dropdown-toggle" v-on:click="logout" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="menu-icon fa fa-sign-out fa-mt-4"></i><strong class="text-secondary">로그아웃</strong>
                        </a>
                    </div>
                </div>
            </div>

        </header><!-- /header -->
        <!-- Header-->
        <router-view></router-view>
        <b-modal id="user-pop"
                            ref="userDetail"
                            centered
                            title="사용자 정보"
                            :ok-only="true"
                            ok-title="닫기"
                            :no-close-on-backdrop="true"
                            :no-close-on-esc="true"
                            @hidden="initUserInfo">

                        <!-- <b-container fluid v-if="employee != null">

                        </b-container> -->
            <b-card v-if="user != null">
                <b-form>
                    <b-form-group
                    label="이름"
                    label-for="empName"
                    :label-cols="3"
                    :horizontal="true">

                        <b-form-input id="empName" type="text" placeholder="이름"
                                    v-model="user.name"
                                    data-vv-delay="500"
                                    data-vv-name="name"
                                    readonly="readonly"
                                    v-validate="'required|max:10'">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                    label="아이디"
                    label-for="loginId"
                    :label-cols="3"
                    :horizontal="true">
                        <b-form-input id="loginId" type="text" placeholder="로그인 아이디"
                                    v-model="user.webId"
                                    readonly="readonly"
                                    v-validate="'max:50'">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                    label="비밀번호"
                    label-for="loginPasswd"
                    :label-cols="3"
                    :horizontal="true">
                        <b-input-group>
                            <b-form-input id="loginPasswd" type="password" placeholder="변경 할 비밀번호 입력"
                                        v-model="user.webLoginPasswd"
                                        v-validate="'required|max:50'">
                            </b-form-input>
                            <b-input-group-append>
                                <b-button class="mb-2 ml-2" size="sm" @click="modifyPasswd($event)">변경</b-button>
                            </b-input-group-append>
                            <span v-show="errors.has('loginPasswd')" class="c_red p-5-10">* 비밀번호를 입력해주세요({{ errors.first('loginPasswd') }})</span>
                        </b-input-group>
                    </b-form-group>
                </b-form>
            </b-card>
        </b-modal>
    </div><!-- /#right-panel -->

    </div>

</template>
<script>
import {mapGetters} from 'vuex'
import userApi from '../../api/user'
import ResultMessage from '../../data/resultMessage'

export default {
    name: 'MainContainer',
    data() {
        return {
            user: null
        }
    },
    computed: mapGetters({
        userAccount: 'userAccount/userAccount'
    }),
    methods: {
        // 정규표현식으로 '/bmw' or '/kia' or '/chungbang' 무시하도록
        isActive : function (path) {
            let currentPath = this.$route.path;
            if(path == '/main/usageHistory' && this.$route.path == '/main')
                return true;
            if(currentPath.match(path))
                return true;
            return false;
        },
        showUserDetail: function() {
            let resultMessage = new ResultMessage();
            userApi.getInfo(this.userAccount.corpNo).then(response => {
                resultMessage.buildSuccessMessage(response);
                this.user = resultMessage.payload;
                this.$refs.userDetail.show();
            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            })
        },
        modifyPasswd: function(event) {
            event.preventDefault();
            if(confirm('변경 하시겠습니까?') == false) return;

            let resultMessage = new ResultMessage();
            userApi.modifyPassword(this.user.webLoginPasswd).then(response => {
                resultMessage.buildSuccessMessage(response);
                alert('변경 되었습니다.');

            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            })
        },
        logout: function() {
            this.$store.dispatch('userAccount/logout').then(()=>{
                this.$router.push('/login');
            });
        },
        initUserInfo: function() {
            this.user = null;
        }
    }
}
</script>

<style>
.useage-table-th {
    width: 200px;
}
</style>





// WEBPACK FOOTER //
// src/components/container/MainContainer.vue